import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap-5';
import LoadingBar from '../../call_lists/import/loading_bar';
import { getRethinkCallListSync } from '../../../helpers/prospect_api';
import { type RethinkCallListSync } from 'bundles/connect/types';

type RethinkSyncModalExportingProps = {
  rethinkSync: RethinkCallListSync,
  willContact?: boolean;
  onHide: () => void,
  onSyncComplete: () => void
}

export default function RethinkSyncModalExporting(
  { rethinkSync, willContact = false, onHide, onSyncComplete }: RethinkSyncModalExportingProps
) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(async () => {
      const data = await getRethinkCallListSync(rethinkSync.id);
      if (data.syncProgress === 100) {
        onSyncComplete();
      } else {
        setProgress(data.syncProgress);
      }
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Modal.Header closeButton>
        <h5 className="mb-0">Adding to List</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2">
          We're adding records to the list.
          Feel free to close this dialog {willContact && "and we'll notify you when it's complete."}
        </div>
        <LoadingBar progress={progress} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </>
  );
}
